import { Box } from "@mui/material";
import ContentWrap from "@/DocLayout/Content/Index";
import { CWALLET_USERID } from "@/config";
import CodeSnippet from "@/components/CodeSnippet";
import Table from "@/DocLayout/Table";
import { useLocales } from "@/locales";
import { CommonWrap } from "../common";
import { ChooseCodeLanguageContext } from "@/components/ChooseCodeLanguage/ChooseCodeLanguage";
import { useContext } from "react";
import { codeMap } from "@/PageCodeComponents/PublicResourceApi";
import PostRequest from "@/components/PostRequest";
export default function Index() {
  const { translate } = useLocales();
  const { language } = useContext(ChooseCodeLanguageContext);
  return (
    <div>
      {/* 获取Cwallet用户信息 */}
      <ContentWrap
        id="get-cwallet-user-information"
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box className="title_0">
              {translate("public_resource.get_coin_list_res_table_desc_13")}
            </Box>
            <Box className="desc">
              {translate("public_resource.get_coin_list_res_table_desc_14")}
            </Box>
            <Box className="title_1">{translate("common.http_request")}</Box>
            <Box className="desc link">
              <PostRequest url={CWALLET_USERID} />
            </Box>
            <Box className="title_1">{translate("common.http_params")}</Box>
            <Table
              tableData={[
                {
                  name: "cwalletUserId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate(
                    "public_resource.get_coin_list_res_table_desc_15"
                  )}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={codeMap["cwallet_user"][language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取Cwallet用户信息 返回 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: "",
                },

                {
                  name: "data.cwalletUserId",
                  type: "String",
                  desc: `${translate(
                    "public_resource.get_coin_list_res_table_desc_15"
                  )}`,
                },
                {
                  name: "data.cwalletUserName",
                  type: "String",
                  desc: `${translate(
                    "public_resource.get_coin_list_res_table_desc_16"
                  )}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["cwallet_user"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
    </div>
  );
}
